/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { Fragment, ComponentPropsWithoutRef, FC, memo } from "react";
import { components } from "react-select";
import { sizes } from "../../../constants/spacing";
import { Checkbox } from "../../checkbox";
import { StyledOption } from "./StyledOption";

const StyledMultiSelectCheckbox = memo(styled(Checkbox)`
    margin-right: ${sizes.xSmall}px;
    vertical-align: middle;
`);

export type CheckboxOptionProps = ComponentPropsWithoutRef<typeof components.Option> & {
    checkedState: "checked" | "unchecked" | "indeterminate";
};

const noopClickHandler = () => {
    // Nothing here intentionally - the Checkbox is purely presentational.
    // Its state is controlled by its parents.
};

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const CheckboxOption: FC<CheckboxOptionProps> = (props) => {
    const { checkedState, children, isDisabled, isFocused, isSelected } = props;

    return (
        <StyledOption
            className={props.className}
            ref={props.innerRef}
            // TODO optionHeight should be moved to the LayoutContext.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            height={props.selectProps.optionHeight}
            isDisabled={isDisabled}
            isFocused={isFocused}
            isSelected={isSelected}
            {...props.innerProps}
        >
            <Fragment>
                <StyledMultiSelectCheckbox
                    aria-hidden
                    tabIndex={-1}
                    checkedState={checkedState}
                    isDisabled={isDisabled}
                    onClick={noopClickHandler}
                />
                {children}
            </Fragment>
        </StyledOption>
    );
};
